import React from 'react';
import PropTypes from 'prop-types';

import {connect} from '@stubhub/react-store-provider';

import {query} from '../../../../modules/react-query';

// Controller
import controller from './controller';

function withTicketListData(InnerComp) {
  @query({
    priceWithFees: 'priceWithFees',
    sectionIdList: 'sid',
    zoneIdList: 'zid',
  })
  @connect(controller)
  class TicketListDataProvider extends React.Component {
    handleSelectTicket =
      (listing) =>
      (...args) => {
        const {handleSelectTicket} = this.props;
        handleSelectTicket(...args, listing);
      };
    setPage = (page) => {
      const {listingLoading, setPage} = this.props;
      if (!listingLoading && page) {
        setPage(page);
      }
    };

    handleHoveredListingSectionId = (sectionId, zoneId) => {
      const {updateHoveredSectionId, updateHoveredZoneId} = this.props;
      updateHoveredSectionId && updateHoveredSectionId(sectionId);
      updateHoveredZoneId && updateHoveredZoneId(zoneId);
    };

    render() {
      return (
        <InnerComp
          {...this.props}
          setPage={this.setPage}
          handleSelectTicket={this.handleSelectTicket}
          handleHoveredListingSectionId={this.handleHoveredListingSectionId}
        />
      );
    }
  }

  TicketListDataProvider.propTypes = {
    /** Array of section ids */
    sectionIdList: PropTypes.array,

    /** Array of zone ids */
    zoneIdList: PropTypes.array,

    /** Method to hover selected section */
    updateHoveredSectionId: PropTypes.func,

    /** Method to hover selected section */
    updateHoveredZoneId: PropTypes.func,

    /** Method to handle selected ticket */
    handleSelectTicket: PropTypes.func,

    /** If listing is loading */
    listingLoading: PropTypes.bool,

    /** Method for loading more elements */
    setPage: PropTypes.func,
  };

  return TicketListDataProvider;
}

export default withTicketListData;
